import {
  ColumnConfiguration,
  ColumnConfigurationRenderAs,
} from '@april9au/stack9-sdk';

import { ListTable } from '../../components/ListTable/ListTable';
import { OccupationDrawerAction } from '../../components/ListViewCustomComponents';
import { Occupation } from '../../models/stack9/Occupation';

const Drawer = OccupationDrawerAction.default;

type Props = {
  countrySetupId: number;
  initialValues?: Partial<Occupation>;
};
const OccupationInfo = ({ countrySetupId, initialValues }: Props) => {
  const columns: ColumnConfiguration[] = [
    {
      label: 'Code',
      field: 'code',
      renderAs: ColumnConfigurationRenderAs.CustomComponent,
      value: '{{code}}',
      options: {
        customComponentName: 'OccupationDrawerAction',
      },
    },
    {
      label: 'Name',
      field: 'name',
      renderAs: ColumnConfigurationRenderAs.Text,
      value: '{{name}}',
    },
    {
      label: 'Is active',
      field: 'is_active',
      renderAs: ColumnConfigurationRenderAs.EnumTags,
      value: '{{is_active}}',
      options: {
        enumColor: {
          Yes: 'green',
          No: 'red',
        },
      },
    },
  ];

  return (
    <ListTable
      queryVars={{ countrySetupId }}
      columns={columns}
      title="Occupations"
      queryName="getoccupationlistbycountrysetup"
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'end',
          marginBottom: '15px',
        }}
      >
        <Drawer row={{ ...initialValues }} />
      </div>
    </ListTable>
  );
};

export default OccupationInfo;
